
import React from 'react';

const PortalsBenefits = () => {
  const benefits = [
    {
      title: 'Verbesserte Kundenerfahrung',
      description: 'Bieten Sie Ihren Kunden ein nahtloses, personalisiertes Erlebnis mit Self-Service-Optionen und transparenten Prozessen.',
      icon: (
        <svg className="h-12 w-12 text-indigo-700" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M21 8V16C21 18.2 19.2 20 17 20H7C4.8 20 3 18.2 3 16V8C3 5.8 4.8 4 7 4H17C19.2 4 21 5.8 21 8Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M14.5 15C15.3284 15 16 14.3284 16 13.5C16 12.6716 15.3284 12 14.5 12C13.6716 12 13 12.6716 13 13.5C13 14.3284 13.6716 15 14.5 15Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M3 9H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M7 15H9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      )
    },
    {
      title: 'Effiziente Zusammenarbeit',
      description: 'Fördern Sie die Kooperation zwischen Mitarbeitern, Partnern und Kunden durch zentrale Kommunikationsplattformen.',
      icon: (
        <svg className="h-12 w-12 text-indigo-700" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M17 20H7C4.8 20 3 18.2 3 16V8C3 5.8 4.8 4 7 4H17C19.2 4 21 5.8 21 8V16C21 18.2 19.2 20 17 20Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M11 12C12.1046 12 13 11.1046 13 10C13 8.89543 12.1046 8 11 8C9.89543 8 9 8.89543 9 10C9 11.1046 9.89543 12 11 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M16 15C16 13.3 13.7 12 11 12C8.3 12 6 13.3 6 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M16 8H16.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M16 11H16.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      )
    },
    {
      title: 'Reduzierter Verwaltungsaufwand',
      description: 'Automatisieren Sie wiederkehrende Aufgaben und entlasten Sie Ihre Mitarbeiter durch Self-Service-Funktionen und digitale Prozesse.',
      icon: (
        <svg className="h-12 w-12 text-indigo-700" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M22 10V15C22 20 20 22 15 22H9C4 22 2 20 2 15V9C2 4 4 2 9 2H14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M22 10H18C15 10 14 9 14 6V2L22 10Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M7 13H13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M7 17H11" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      )
    },
    {
      title: 'Höhere Kundenzufriedenheit',
      description: 'Steigern Sie die Kundenbindung durch transparente Prozesse, schnellere Reaktionszeiten und personalisierte Angebote.',
      icon: (
        <svg className="h-12 w-12 text-indigo-700" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8 2V5M16 2V5M3.5 9.09H20.5M21 8.5V17C21 20 19.5 22 16 22H8C4.5 22 3 20 3 17V8.5C3 5.5 4.5 3.5 8 3.5H16C19.5 3.5 21 5.5 21 8.5Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M11.995 13.7H12.005M8.294 13.7H8.304M15.695 13.7H15.705M11.995 17.7H12.005M8.294 17.7H8.304M15.695 17.7H15.705" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      )
    },
    {
      title: 'Stärkere Partnerbindung',
      description: 'Vertiefen Sie Geschäftsbeziehungen durch einfache Zusammenarbeit, gemeinsamen Zugriff auf Ressourcen und optimierte Prozesse.',
      icon: (
        <svg className="h-12 w-12 text-indigo-700" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M15.5 9.75C16.3284 9.75 17 9.07843 17 8.25C17 7.42157 16.3284 6.75 15.5 6.75C14.6716 6.75 14 7.42157 14 8.25C14 9.07843 14.6716 9.75 15.5 9.75Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M8.5 9.75C9.32843 9.75 10 9.07843 10 8.25C10 7.42157 9.32843 6.75 8.5 6.75C7.67157 6.75 7 7.42157 7 8.25C7 9.07843 7.67157 9.75 8.5 9.75Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M8.4 17.7H8.5M15.5 17.7H15.6M12 15.7V17.7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      )
    },
    {
      title: 'Optimierte Geschäftsprozesse',
      description: 'Steigern Sie die Effizienz durch digitalisierte, automatisierte Workflows und schnelleren Informationsaustausch.',
      icon: (
        <svg className="h-12 w-12 text-indigo-700" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M21.4399 10.64L13.2399 18.83C11.9999 20.07 10.0099 20.07 8.76989 18.83L2.94989 13.01C1.70989 11.77 1.70989 9.78004 2.94989 8.54004L11.1499 0.350037C11.7199 -0.219963 12.6699 -0.0699625 13.0199 0.650038L15.9999 6.60004C16.2099 7.04004 16.0799 7.57004 15.6899 7.84004C15.2899 8.11004 14.7499 8.05004 14.4399 7.70004L11.7599 4.56004C11.5299 4.29004 11.1199 4.26004 10.8499 4.49004C10.5799 4.72004 10.5499 5.13004 10.7799 5.40004L13.2799 8.38004C13.6799 8.85004 13.5999 9.55004 13.1199 9.95004C12.6399 10.35 11.9499 10.27 11.5499 9.80004L8.7799 6.57004C8.5399 6.28004 8.1199 6.25004 7.84989 6.49004C7.57989 6.73004 7.5499 7.16004 7.7899 7.43004L10.5599 10.65C10.9599 11.12 10.8799 11.82 10.4099 12.22C9.9299 12.62 9.2399 12.53 8.8399 12.07L6.4399 9.27004C6.1999 8.98004 5.7799 8.95004 5.5099 9.19004C5.2399 9.43004 5.2099 9.84004 5.4399 10.12L8.1599 13.29C8.4599 13.65 8.4099 14.19 8.0599 14.5C7.6899 14.81 7.1399 14.79 6.7699 14.43L4.8599 12.52C4.6599 12.32 4.3399 12.32 4.1499 12.52C3.9499 12.72 3.9499 13.05 4.1499 13.25L8.7699 17.88C9.5799 18.69 10.9199 18.69 11.7299 17.88L18.6199 10.99C19.5399 10.07 19.1299 9.31004 18.7899 9.00004C18.3499 8.58004 17.4799 8.44004 16.5699 9.36004L15.1199 10.81C14.7999 11.13 14.2899 11.13 13.9699 10.81C13.6499 10.49 13.6499 9.98004 13.9699 9.66004L17.1999 6.43004C18.3799 5.25004 19.8899 5.68004 20.5899 6.36004C21.3799 7.13004 22.6199 8.64004 21.4399 10.64Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      )
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">Vorteile digitaler Portallösungen</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Mit maßgeschneiderten Portalen schaffen Sie Mehrwert für Ihre Kunden, Partner und Mitarbeiter und optimieren Ihre Geschäftsprozesse.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <div key={index} className="bg-white p-6 rounded-xl shadow hover:shadow-lg transition-shadow duration-300">
              <div className="flex flex-col items-center mb-6">
                <div className="p-3 bg-indigo-50 rounded-full mb-4">
                  {benefit.icon}
                </div>
                <h3 className="text-xl font-bold text-gray-800 text-center">{benefit.title}</h3>
              </div>
              <p className="text-gray-600 text-center">{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PortalsBenefits;
